import {TextLinkWidget} from '@tableau/widgets';
import React from 'react';

import {FormikCheckbox} from '~commonInfra/components/FormikCheckbox';
import { HelpService } from '~commonInfra/services/HelpService';
import {SettingsSection} from '~src/settings/components/common/SettingsSection';
import {PrepExtensionsSettingsSubFormikProps} from '~src/settings/extensions-settings/ExtensionsSettingsCoordinator';
import {ExtensionsSettingsSubspaceState} from '~src/settings/extensions-settings/ExtensionsSettingsSubspaceShared';
import {useFormikContext} from '~src/settings/FormikWrapperForStubbing';
import {componentRegistryEntry} from '~src/settings/general-settings/components/SettingsComponentRegistryFunctions';
import {learnMoreStyle} from '~src/settings/styles/CommonStyles';
import {ISiteAdminSettings, ISiteSubscriptionSettings} from '~src/settings/types/ISiteSettingsForSiteAdmin';
import {Sites} from '~src/siteManagement/services/resources/Sites';

import { Messages } from '../../../codegen/Localize';

const PREP_EINSTEIN_ENABLED_FIELD = 'settings.siteSettingsForSiteAdmin.siteAdminSettings.einsteinInFlowEnabled';

export const PREP_EXTENSIONS_SITE_SETTING_EINSTEIN_CHECKBOX_TESTID = 'prep-extensions-enable-site-einstein-checkbo-test-id';
export const PREP_EXTENSIONS_SITE_SETTINGS_EINSTEIN_TESTID = 'prep-extensions-einstein-site-setting-test-id';

function createDescription(): JSX.Element {
  return (
    <div>
      {Messages.prepExtensionsSiteDescription()}
      <TextLinkWidget
        testId={'prep-extensions-link'}
        target={'_blank'}
        className={learnMoreStyle}
        href={HelpService.getServerHelpUrlByCategory('prep_predictions')}
      >
        {Messages.learnMore()}
      </TextLinkWidget>
    </div>
  );
}


export function PrepExtensionsSiteSection(_props: PrepExtensionsSettingsSubFormikProps) {
  const formik = useFormikContext<PrepExtensionsSettingsSubFormikProps>();
  return (
    <div>
      <SettingsSection
        title={Messages.prepExtensions()}
        description={createDescription()}
        testId={PREP_EXTENSIONS_SITE_SETTINGS_EINSTEIN_TESTID}
      >
        <FormikCheckbox
          checked={formik.getFieldProps(PREP_EINSTEIN_ENABLED_FIELD).checked}
          label={Messages.prepExtensionsEinsteinSiteLabel()}
          name={PREP_EINSTEIN_ENABLED_FIELD}
          testId={PREP_EXTENSIONS_SITE_SETTING_EINSTEIN_CHECKBOX_TESTID}
        />
      </SettingsSection>
    </div>
  );
}

export const PrepExtensionsSiteSectionSpecs = componentRegistryEntry({
  name: 'PrepExtensionsSiteSection',
  component: PrepExtensionsSiteSection,
  onSubmit: async (settings: ExtensionsSettingsSubspaceState) => {
    const siteAdminSettings = settings.siteSettingsForSiteAdmin.siteAdminSettings as ISiteAdminSettings;
    const subscriptionSettings = settings.siteSettingsForSiteAdmin.subscriptionSettings as ISiteSubscriptionSettings;
    await Promise.all([Sites.instance.updateSiteSettingsForSiteAdmin((settings.siteSettingsForSiteAdmin as any).id || settings.siteSettingsForSiteAdmin.siteId, siteAdminSettings, subscriptionSettings)]);
  },
});
